module.exports = __webpack_public_path__ + "194a4b1464d9b0cfeb88cad991427256.jpg";